import { apiDateFormat } from "@chhjit/react-components";
import moment from "moment-timezone";

import { resolveIanaTimeZone } from "./resolve-iana-timezone";

/**
 * Today's date (YYYY-MM-DD) in the franchise location's own timezone, from
 * the legacy DB timezone abbreviation (`location.timeZone.shortName`).
 * Falls back to the browser's local date when the abbreviation is unknown —
 * still closer to the customer's "today" than the server's UTC date.
 *
 * Used as the `creationDate` for promo validation, mirroring MET's
 * usePromoCodeCheck (`moment(locationsDateTime).format(apiDateFormat)`):
 * when omitted, the pricing API defaults to the server's UTC date, which
 * around midnight is a day off from the customer's — a promo whose
 * availability window ends "today" would be wrongly rejected (or one
 * starting "tomorrow" wrongly accepted).
 */
export const todayInLocationZone = (timeZoneAbbreviation?: string): string => {
  const ianaZone = resolveIanaTimeZone(timeZoneAbbreviation);
  return (ianaZone ? moment().tz(ianaZone) : moment()).format(apiDateFormat);
};
